export const REQUEST_URI_TOO_LONG = 'REQUEST_URI_TOO_LONG'

const PETE_ERROR_MESSAGES = {
  [REQUEST_URI_TOO_LONG]: "We couldn't process this search. Try narrowing your search and giving it another try."
}

export function getPeteErrorMessage(code) {
  return code ? PETE_ERROR_MESSAGES[code] : undefined
}




// WEBPACK FOOTER //
// client/utils/pete_error_codes.js